// extracted by mini-css-extract-plugin
export default {"error":"EducationForm_error__OYpaq"};